import { application } from "./application.js"
import ThemeController from "./theme_controller.js"
import ToggleController from "./toggle_controller.js"
import FancyboxController from "./fancybox_controller.js";

application.register("theme", ThemeController)
application.register("toggle", ToggleController)
application.register("fancybox", FancyboxController)
